import { DEFAULT_WHITELABEL_ID } from './whitelabels/registry';

/** Chart / dashboard series colors; aligned with legacy `THEME_TO_PALETTE_OPTIONS_MAPPING`. */
export type DashboardPaletteColors = {
  firstColor: string;
  secondColor: string;
  thirdColor: string;
  fourthColor: string;
};

const LEADZAI_DEFAULT: DashboardPaletteColors = {
  firstColor: '#695EDE',
  secondColor: '#36A1AF',
  thirdColor: '#3ABD9F',
  fourthColor: '#9CBBFF',
};

/** Per-whitelabel dashboard colors (legacy theme parity). */
const DASHBOARD_PALETTE_BY_WHITELABEL: Record<string, DashboardPaletteColors> = {
  leadzai: LEADZAI_DEFAULT,
  'pag-amrl': {
    firstColor: '#685BC7',
    secondColor: '#E1508C',
    thirdColor: '#ED874D',
    fourthColor: '#BAC75B',
  },
  'fcr-be': {
    firstColor: '#00ABC2',
    secondColor: '#5E9BE2',
    thirdColor: '#C17CC6',
    fourthColor: '#E86877',
  },
  youvia: {
    firstColor: '#FFFF00',
    secondColor: '#131D3A',
    thirdColor: '#F8DAD5',
    fourthColor: '#FEFCF8',
  },
  pblcrEst: LEADZAI_DEFAULT,
  mediamag: {
    firstColor: '#E9B83E',
    secondColor: '#595447',
    thirdColor: '#F6EDDE',
    fourthColor: '#7F95AC',
  },
  'bee-ddt': {
    firstColor: '#E95C1D',
    secondColor: '#801DD4',
    thirdColor: '#FFA425',
    fourthColor: '#06DADE',
  },
  medialuo: LEADZAI_DEFAULT,
  loclsrch: LEADZAI_DEFAULT,
  linkmerc: LEADZAI_DEFAULT,
};

export function resolveDashboardPaletteColors(whitelabelId: string | undefined): DashboardPaletteColors {
  const id = whitelabelId && whitelabelId in DASHBOARD_PALETTE_BY_WHITELABEL ? whitelabelId : DEFAULT_WHITELABEL_ID;
  return DASHBOARD_PALETTE_BY_WHITELABEL[id] ?? LEADZAI_DEFAULT;
}
